import React from 'react';
import ContactContainer from '../../Componant/Contact/ContactApp';

const ContactApp = () => {
  return (
    <div className='page-body'>
      <ContactContainer />
    </div>
  );
};

export default ContactApp;
